<script lang="ts" setup>
import { onMounted, onUnmounted } from "vue";

const props = withDefaults(
  defineProps<{
    withNav?: boolean;
  }>(),
  {
    withNav: true,
  }
);

onMounted(() => {
  const body = document.querySelector("body");
  body?.classList.add("global-scroll");
});
onUnmounted(() => {
  const body = document.querySelector("body");
  body?.classList.remove("global-scroll");
});
</script>
<template>
  <div
    :class="{ 'pt-[var(--top-nav-height)] md:pt-0': props.withNav }"
    class="min-h-screen lg:h-full lg:overflow-scroll lg:overflow-x-hidden"
  >
    <div
      class="fixed md:sticky w-full top-0 z-20 van-safe-area-top sm:w-[600px] lg:w-full"
    >
      <slot name="nav"></slot>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<style>
:root body.global-scroll {
  width: 100%;
  @apply overflow-y-auto lg:overflow-hidden lg:h-screen;
}

.global-scroll #app {
  @apply h-auto lg:overflow-hidden lg:h-full;
}

.global-scroll aside {
  @apply h-[calc(var(--vh,1vh)*100,100vh)];
}
</style>
